import React from 'react';
import styles from './index.module.scss';

const VideoComponent = ({
  contentData,
  contentText,
  contentName,
  imgName,
  imgsNames,
  videoName,
  path_to_folder,
}) => {

  // Обработка videoName - оставляем только часть после последнего '\'
  const processedVideoName =
    videoName && videoName.includes('\\')
      ? videoName.substring(videoName.lastIndexOf('\\') + 1)
      : videoName;

  // Обработка imgName - оставляем только часть после последнего '\'
  const processedImgName =
    imgName && imgName.includes('\\') ? imgName.substring(imgName.lastIndexOf('\\') + 1) : imgName;

  return (
    <div className={styles.videoComponent}>
      <h2 className={styles.title}>Видео Компонент</h2>
      <p className={styles.description}>Компонент для отображения видео</p>
      {imgName && imgName !== 'none' && (
        <div className={styles.imageContainer}>
          <h4>Изображение:</h4>
          <p className={styles.imagePath}>Путь: {path_to_folder + processedImgName}</p>
          <img src={path_to_folder + processedImgName} alt='Изображение' className={styles.image} />
        </div>
      )}
      {imgName && imgName === 'none' && (
        <div className={styles.additionalData}>
          <h4>Имя изображения:</h4>
          <p>{imgName}</p>
        </div>
      )}
      {videoName && videoName !== 'none' && (
        <div className={styles.videoContainer}>
          <h4>Видео:</h4>
          <p className={styles.videoPath}>Путь: {path_to_folder + processedVideoName}</p>
          <video src={path_to_folder + processedVideoName} controls className={styles.video}>
            Ваш браузер не поддерживает видео.
          </video>
        </div>
      )}
      {videoName && videoName === 'none' && (
        <div className={styles.additionalData}>
          <h4>Имя видео:</h4>
          <p>{videoName}</p>
        </div>
      )}
    </div>
  );
};

export default VideoComponent;
